import React from 'react';
import { containerClass, ContactCta, Eyebrow, leadClass, sectionTitleClass } from './ui';

const activities = [
  {
    name: 'Segelflug',
    description: 'Erleben Sie die ruhige Eleganz des Segelflugs und segeln Sie durch die Lüfte.',
  },
  {
    name: 'Ultraleichtflug (UL-Flug)',
    description: 'Steuern Sie leichte und wendige Flugzeuge und genießen Sie die Freiheit des Fliegens.',
  },
  {
    name: 'Gastflüge',
    description: 'Buchen Sie einen Gastflug mit unseren erfahrenen Piloten und erleben Sie den Himmel aus erster Hand.',
  },
];

const Activities: React.FC = () => {
  return (
    <section id="aktivitaeten" className="border-t border-gray-200 bg-gray-50">
      <div className={`${containerClass} py-10 lg:grid lg:grid-cols-[5fr_7fr] lg:gap-16 lg:py-[72px]`}>
        <div>
          <Eyebrow>Aktivitäten</Eyebrow>
          <h2 className={`${sectionTitleClass} mb-3 lg:mb-4`}>Unsere Angebote</h2>
          <p className={`${leadClass} mb-6 lg:mb-7 lg:max-w-[40ch]`}>
            Ob Anfänger oder Profi – bei uns finden Sie die passende Aktivität. Erleben Sie die Faszination des Fliegens hautnah!
          </p>
          <ContactCta className="!hidden lg:!inline-flex">Buchen Sie jetzt Ihren Gastflug!</ContactCta>
        </div>

        <ol className="lg:border-t-2 lg:border-gray-900">
          {activities.map((activity, index) => (
            <li
              key={activity.name}
              className="grid grid-cols-[36px_1fr] gap-x-3.5 gap-y-1 border-t border-gray-200 py-[18px] lg:grid-cols-[48px_260px_1fr] lg:items-baseline lg:gap-5 lg:border-b lg:border-t-0 lg:py-[22px]"
            >
              <span aria-hidden="true" className="pt-1 text-[13px] font-extrabold text-blue-600 lg:pt-0 lg:text-sm">
                {String(index + 1).padStart(2, '0')}
              </span>
              <h3 className="text-[19px] font-semibold lg:text-[22px] lg:tracking-[-0.01em]">{activity.name}</h3>
              <p className="col-start-2 text-[15px] leading-normal text-gray-600 lg:col-start-auto">{activity.description}</p>
            </li>
          ))}
        </ol>

        <ContactCta className="mt-4 lg:!hidden">Buchen Sie jetzt Ihren Gastflug!</ContactCta>
      </div>
    </section>
  );
};

export default Activities;
